module.exports = __webpack_public_path__ + "static/media/alert-circle.8f17874d.svg";